var map = {
	"./annakarenina/1-1.jpg": "c3ec",
	"./annakarenina/2-1.jpg": "396e",
	"./annakarenina/3-1.jpg": "07eb",
	"./annakarenina/4-1.jpg": "a3d4",
	"./crime/1-1.jpg": "9fac",
	"./crime/2-1.jpg": "2b5a",
	"./crime/3-1.jpg": "36a4",
	"./crime/4-1.jpg": "e479",
	"./prideprejudice/1-1.jpg": "6877",
	"./prideprejudice/2-1.jpg": "1fe3",
	"./prideprejudice/3-1.jpg": "ebbb",
	"./prideprejudice/4-1.jpg": "0a13",
	"./shakespeare/1-1.jpg": "b92f",
	"./shakespeare/2-1.jpg": "f934",
	"./shakespeare/3-1.jpg": "3727",
	"./shakespeare/4-1.jpg": "2339",
	"./sherlock/1-1.jpg": "e7f1",
	"./sherlock/2-1.jpg": "0988",
	"./sherlock/3-1.jpg": "0eab",
	"./sherlock/4-1.jpg": "a0b0",
	"./wind/1-1.jpg": "3acc",
	"./wind/2-1.jpg": "0b35",
	"./wind/3-1.jpg": "a368",
	"./wind/4-1.jpg": "aada"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "73a0";